import { Component, Input } from '@angular/core';

@Component({
  selector: 'ng-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent {

  @Input() size: string;
  @Input() color: string;
  @Input() circleSize: string;

}
